import { Dots3 } from "../../../assets/icons";
import React, { useState, useEffect, ReactNode, useRef } from "react";

interface IconDropdownProps {
    options: {
        id: number;
        name: string;
        value: string;
        icon?: ReactNode;
        disabled?: boolean;
    }[];
    onSelect: (selected: string, record?: any) => void;
    optionHeading: string;
    dropdownIcon: boolean;
    width?: string;
    rowIndex: number;
}

const IconDropdown: React.FC<IconDropdownProps> = ({
    width = "200px",
    options,
    onSelect,
    optionHeading,
    rowIndex,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [openUpward, setOpenUpward] = useState(false);
    const [adjustedLeft, setAdjustedLeft] = useState(false);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)
        ) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = (e: any) => {
        e?.stopPropagation();
        if (!isOpen && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const viewportWidth = window.innerWidth;

            setOpenUpward(rect.bottom + 200 > viewportHeight);

            const dropdownWidth = parseInt(width);
            if (rect.left + dropdownWidth > viewportWidth) {
                setAdjustedLeft(true);
            } else {
                setAdjustedLeft(false);
            }
        }

        setIsOpen(!isOpen);
    };

    return (
        <div className="relative w-full" ref={dropdownRef}>
            <Dots3
                size={18}
                onClick={(e: any) => toggleDropdown(e)}
                className="outline-none justify-between items-center w-[18px] cursor-pointer"
                color="#F7F9F9"
            />
            {isOpen && (
                <div
                    className={`border-[1px] border-darkcolor-400 absolute z-[1001] mt-[3px] rounded-[8px] shadow-lg bg-darkcolor-700 ${openUpward
                        ? rowIndex <= 1
                            ? "top-full mt-[3px]"
                            : "bottom-full mb-[3px]"
                        : "top-full mt-[3px]"
                        }`}
                    style={{
                        width: width,
                        right: adjustedLeft ? 0 : "auto",
                        left: adjustedLeft ? "auto" : 0,
                    }}
                >
                    <div>
                        <div className="block px-4 py-2 text-[14px] cursor-auto border-b-[1px] border-darkcolor-400 text-neutral-25 bg-darkcolor-800 rounded-t-[8px]">
                            {optionHeading}
                        </div>
                        {options.map((option, index) => (
                            <div
                                key={option?.id}
                                className={`text-[16px] py-[10px] pl-[12px] pr-[10px] hover:bg-darkcolor-600 cursor-pointer text-neutral-25 flex items-center justify-between bg-darkcolor-800  ${option.disabled ? "cursor-not-allowed opacity-50" : ""
                                    } ${index === options.length - 1 ? "rounded-b-[8px]" : ""}`}
                                onClick={() => {
                                    if (!option?.disabled) {
                                        onSelect(option.value);
                                        setIsOpen(false);
                                    }
                                }}
                            >
                                <div className="flex items-center">
                                    {option?.icon}
                                    <p className="ml-[8px]">{option.name}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default IconDropdown;
